import red from './red.png';
import blue from './blue.png';
import yellow from './yellow.png';
import gold from './gold.png';
import silver from './silver.png';
import crystal from './crystal.png';
import ruby from './ruby.png';
import sapphire from './sapphire.png';
import emerald from './emerald.jpg';
import fireRed from './fireRed.png';
import leafGreen from './leafGreen.png';
import diamond from './diamond.jpg';
import pearl from './pearl.jpg';
import platinum from './platinum.png';
import heartGold from './heartGold.jpg';
import soulSilver from './soulSilver.jpg';
import black from './black.png';
import white from './white.png';
import blackTwo from './blackTwo.png';
import whiteTwo from './whiteTwo.png';
import x from './x.png';
import y from './y.png';
import omegaRuby from './omegaRuby.png';
import alphaSapphire from './alphaSapphire.png';
import sun from './sun.png';
import moon from './moon.png';
import ultraSun from './ultraSun.png';
import ultraMoon from './ultraMoon.png';
import letsGoPikachu from './letsGoPikachu.png';
import letsGoEevee from './letsGoEevee.png';
import sword from './sword.png';
import shield from './shield.png';
import brilliantDiamond from './brilliantDiamond.png';
import shiningPearl from './shiningPearl.png';
import legendsArceus from './legendsArceus.png';
import scarlet from './scarlet.png';
import violet from './violet.png';

const games = [
	{ name: 'Red', src: red, value: 'red'},
	{ name: 'Blue', src: blue, value: 'blue'},
	{ name: 'Yellow', src: yellow, value: 'yellow'},
	{ name: 'Gold', src: gold, value: 'gold'},
	{ name: 'Silver', src: silver, value: 'silver'},
	{ name: 'Crystal', src: crystal, value: 'crystal'},
	{ name: 'Ruby', src: ruby, value: 'ruby'},
	{ name: 'Sapphire', src: sapphire, value: 'sapphire'},
	{ name: 'Emerald', src: emerald, value: 'emerald'},
	{ name: 'Fire Red', src: fireRed, value: 'fireRed'},
	{ name: 'Leaf Green', src: leafGreen, value: 'leafGreen'},
	{ name: 'Diamond', src: diamond, value: 'diamond'},
	{ name: 'Pearl', src: pearl, value: 'pearl'},
	{ name: 'Platinum', src: platinum, value: 'platinum'},
	{ name: 'Heart Gold', src: heartGold, value: 'heartGold'},
	{ name: 'Soul Silver', src: soulSilver, value: 'soulSilver'},
	{ name: 'Black', src: black, value: 'black'},
	{ name: 'White', src: white, value: 'white'},
	{ name: 'Black 2', src: blackTwo, value: 'blackTwo'},
	{ name: 'White 2', src: whiteTwo, value: 'whiteTwo'},
	{ name: 'X', src: x, value: 'x'},
	{ name: 'Y', src: y, value: 'y'},
	{ name: 'Omega Ruby', src: omegaRuby, value: 'omegaRuby'},
	{ name: 'Alpha Sapphire', src: alphaSapphire, value: 'alphaSapphire'},
	{ name: 'Sun', src: sun, value: 'sun'},
	{ name: 'Moon', src: moon, value: 'moon'},
	{ name: 'Ultra Sun', src: ultraSun, value: 'ultraSun'},
	{ name: 'Ultra Moon', src: ultraMoon, value: 'ultraMoon'},
	{ name: "Let's Go, Pikachu!", src: letsGoPikachu, value: 'letsGoPikachu'},
	{ name: "Let's Go, Eevee!", src: letsGoEevee, value: 'letsGoEevee'},
	{ name: 'Sword', src: sword, value: 'sword'},
	{ name: 'Shield', src: shield, value: 'shield'},
	{ name: 'Brilliant Diamond', src: brilliantDiamond, value: 'brilliantDiamond'},
	{ name: 'Shining Pearl', src: shiningPearl, value: 'shiningPearl'},
	{ name: 'Legends: Arceus', src: legendsArceus, value: 'legendsArceus'},
	{ name: 'Scarlet', src: scarlet, value: 'scarlet'},
	{ name: 'Violet', src: violet, value: 'violet' }
];

export default games;